export { default } from './popup-controller'
export { popupRegister } from './popup-register'
export { effectRegister } from './effect-register'



// WEBPACK FOOTER //
// ./src/components/popup-base/index.js